import {
  InstagramIcon_default
} from "./chunk-LVANA3WF.mjs";
export {
  InstagramIcon_default as default
};
